






























































































import Vue from "vue";
import ReviewCard from "@/parts/util/ReviewCard.vue";
import AdBanner from "@/parts/util/AdBanner.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";
import CorporateTopProjects from '@/parts/corporate/CorporateTopProjects.vue';
import CorporateTopDeals from '@/parts/corporate/CorporateTopDeals.vue';
import CorporateTopNotifications from '@/parts/corporate/CorporateTopNotifications.vue';
import { formatDate, sortedByDateDesc } from "@/utils/momentUtils";

import { GetUserProfileResponse, UserProfile, UserSkill } from "@/api/dto/UserProfile";
import { ReviewRecommendResponse } from "@/api/dto/Review";
import { getRecommendReviews, getRecommendLoggedInReviews } from "@/api/Review";
import { AnnouncementSummary } from "@/api/dto/Announcement";
import { getAnnouncements } from "@/api/Announcement";
import { defaultIconUrl } from "@/properties";
import { hasAccessToken } from "../jwt";
import { getUserProfile } from "../api/UserProfile";
import { notificationsLink } from '@/utils/linkUtils';
import { NotificationsCorporateResponse } from "@/api/dto/Notification";
import { getCorporateNotifications } from "@/api/Notification";
import { EmployeeDealsResponse } from "@/api/dto/Deal"
import { Project } from '@/api/dto/Corporation';
import { getUserProjects, getCorporatePendingDeals } from "@/api/Corporation";

interface Data {
  /**
   * デフォルトアイコン画像
   */
  defaultIconUrl: string;
  /**
   * ログインメッセージ
   */
  loginMessage: string;
  /**
   * 案件
   */
  dealsData: ReviewRecommendResponse[];
  /**
   * お知らせ
   */
  announcementsData: AnnouncementSummary[];
  /**
   * お知らせ表示件数
   */
  announcementListSize: number;
  /**
   * 設定したスキル
   * @example ["C", "Java", "JavaScript"...]
   */
  languages: string[];
  /**
   * 無料利用期間
   */
  isFreeTime: boolean;

  /**
   * ユーザー区分
   */
  userCategory: string;

  /**
   * 法人ユーザのトップページに表示する内容
   */
  corporationUsersView: {
    /**
     * プロジェクト一覧
     */
    projects: Project[],
    /**
     * 通知（取引通知リスト）
     */
    notifications: NotificationsCorporateResponse[];

    /**
     * レビュー中のデータ
     */
    reviewData: EmployeeDealsResponse[];
    /**
     * 法人ユーザ区分(1:承認権限ユーザ,2:一般)
     */
    corporateUserCategory: string;

    // モーダル 関連
    modalOpen: boolean;


    comment: string;
  }
}

export default Vue.extend({
  name: "",
  components: {
    ReviewCard,
    AdBanner,
    ReturnTop,
    CorporateTopProjects,
    CorporateTopDeals,
    CorporateTopNotifications,
  },
  props: {
    logged: Boolean,
  },
  data(): Data {
    return {
      defaultIconUrl,
      loginMessage: "",
      dealsData: [],
      announcementsData: [],
      announcementListSize: 3,
      languages: [],
      isFreeTime: false,
      userCategory: "",
      corporationUsersView: {
        projects: [],
        notifications: [],
        reviewData: [] as EmployeeDealsResponse[],
        corporateUserCategory: "",
        modalOpen: false,
        comment: "",
      }
    };
  },
  async beforeRouteEnter(to, route, next) {
    let userProf = await getUserProfile();
    if (userProf.userCategory === '3') {
      try {
        let projects = [] as Project[];
        let reviewData = [] as EmployeeDealsResponse[];
        let corporateNotif = [] as NotificationsCorporateResponse[];

        // 法人の場合のデータ取得
        projects = await getUserProjects();
        reviewData = await getCorporatePendingDeals();
        corporateNotif = await getCorporateNotifications();

        next(async (vm) => {
          // 別タブでTOP画面を開く際に未ログイン判定をされないため、認証情報の更新を行う
          if (!(vm.$store).getters.hasAuth) {
            (vm.$store).dispatch('updateAuth');
          }
          (vm.$data as Data).corporationUsersView.projects = projects;
          (vm.$data as Data).corporationUsersView.reviewData = reviewData;
          (vm.$data as Data).corporationUsersView.notifications = corporateNotif;
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        const announcementsData = sortedByDateDesc(await getAnnouncements(), (it) => it.lastUpdateAt);
        let dealsData = await getRecommendReviews();

        // 現在ログインしているユーザのプロフィール取得とスキル(言語)の取得
        let userProf: GetUserProfileResponse;
        let lang = [];
        let free = false;
        let category = "";
        try {
          userProf = await getUserProfile();
          lang = userProf.skills.filter((s) => s.type == "1");
          free = userProf.isFreeTime;
          category = userProf.userCategory;
        } catch (e) {
          // 未ログイン、何もしない
          console.log(e);
        }
        // ログイン状態且つスキル(言語)が設定されている場合、おすすめの依頼を取得
        if (hasAccessToken() && lang?.length != 0) {
          dealsData = await getRecommendLoggedInReviews();
        }

        next(async (vm) => {
          (vm.$data as Data).announcementsData = announcementsData;
          (vm.$data as Data).languages = vm.$store.getters.userProfile.skill.language;
          // 別タブでTOP画面を開く際に未ログイン判定をされないため、認証情報の更新を行う
          if (!(vm.$store).getters.hasAuth) {
            (vm.$store).dispatch('updateAuth');
          }
          if (!vm.$props.logged) {
            (vm.$data as Data).loginMessage = "";
            (vm.$data as Data).dealsData = dealsData;
          } else {
            // ログイン済み
            (vm.$data as Data).isFreeTime = free;
            (vm.$data as Data).userCategory = category;
            if (!(vm.$data as Data).languages.length) {
              // ログイン済み・スキル言語未設定
              (vm.$data as Data).loginMessage = "ようこそ！まずはスキルをカスタマイズしましょう";
              // NOTE: スキル未設定の場合は「スキル未設定」を表示
              (vm.$data as Data).languages = ["スキル未設定"];
              if(vm.$store.getters.userProfile.userCategory == '4') {
              (vm.$data as Data).dealsData = dealsData;
              } else {
                (vm.$data as Data).dealsData = dealsData.filter(d=> d.viewPermission == '1');
              }
            } else {
              // ログイン済み・スキル言語設定済み
              (vm.$data as Data).loginMessage = "あなたにおすすめのレビュー依頼を表示しています";
              (vm.$data as Data).languages = (vm.$store.getters.userProfile.skill.language as UserSkill[]).map(
                (item) => item.name
              );
              if(vm.$store.getters.userProfile.userCategory == '4') {
              (vm.$data as Data).dealsData = dealsData;
              } else {
                (vm.$data as Data).dealsData = dealsData.filter(d=> d.viewPermission == '1');
              }
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    }


  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    topAnnounce(): AnnouncementSummary[] {
      return this.announcementsData.slice(0, this.announcementListSize);
    },
  },
  watch: {
    loginData() {
      this.fetchRecommendedReviews();
    },
  },
  methods: {
    notificationsLink,
    async fetchRecommendedReviews() {
      try {
        if (!this.logged) {
          // 未ログイン
          this.loginMessage = "";
          this.dealsData = await getRecommendReviews();
        } else {
          if (!this.loginData.skill.language.length) {
            // ログイン済み・スキル言語未設定
            this.loginMessage = "ようこそ！まずはスキルをカスタマイズしましょう";
            // NOTE: スキル未設定の場合は「HTML5, CSS, JavaScript」を表示
            this.languages = ["HTML5", "CSS", "JavaScript"];
            this.isFreeTime = this.loginData.isFreeTime;
            this.dealsData = await getRecommendReviews();
          } else {
            // ログイン済み・スキル言語設定済み
            this.loginMessage = "あなたにおすすめのレビュー依頼を表示しています";
            this.languages = this.loginData.skill.language.map((item) => item.name);
            this.isFreeTime = this.loginData.isFreeTime;
            this.dealsData = await getRecommendLoggedInReviews();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    onPushPath(path: string) {
      if (path == "/review/draft") {
        this.$store.dispatch("updateAccountStatus");
      }

      this.$router.push(path, () => { });
      this.$emit("pushPath", path);
    },
    formattDate(stringDate:string): string {
      const date = new Date(stringDate);
      const checkMinuites = (time:number): string => {
        if(time<10) {
          return "0"+time;
        }
        return `${time}`
      }
      return `${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日 ${date.getHours()}:${checkMinuites(date.getMinutes())}`;
    },

    dealLink(dealId:string) {  
          this.onPushPath("/review/"+dealId);
    },
    isCorporate(): boolean {
      this.$store.dispatch('updateAuth');
      if (this.$store.getters.userProfile.userCategory == '3') {
        return true;
      } else {
        return false;
      }
      // this.formatNotification("");
      // if (!this.$store.getters.hasAuth) {
      //     this.$store.dispatch('updateAuth');
      //     if(this.$store.getters.userProfile.userCategory != "") {
      //       this.getCorporateDate();
      //     } else {
      //       this.userCategory = this.$store.getters.userProfile.userCategory;
      //     }

      //   }
 
      // return this.userCategory !== '3';    
    },
    formatAmount(amount:string): string{
      switch(amount.length) {
        case 4:
       return "¥"+amount.slice(0,1) + ',' + amount.slice(1);
       case 5:
       return "¥"+amount.slice(0,2) + ',' + amount.slice(2);
      }
      return "¥"+amount
    },

    omitTitle(title:string):string {
      if(title.length > 35) {
       return title.slice(0,35) + "...";
      }
      return title;
    },

    formatNotification(notification:string): string {
      let first = notification.indexOf("「");
      let last = notification.indexOf("」");
      let cutNotification = notification.slice(first,last);
      this.omitTitle(cutNotification) + notification.slice(last);
      return this.omitTitle(cutNotification) + notification.slice(last);
    },
    modalOpen() {
      this.corporationUsersView.modalOpen = true;
    },
    modalClose() {
      this.corporationUsersView.comment = "";
      this.corporationUsersView.modalOpen = false;
    },
  },
  filters: {
    formatDate,
  },
});
